import * as core from '../../../../../../../core'
import * as playground from '../playground'

export const RESOURCE = {
  payload: {
    alias: 'overview',
    appAlias: playground.RESOURCE.payload.alias,
    description: 'Playground overview with both assistant-opening widgets',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Overview',
    page: { alias: 'playground:overview' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
